
import React from 'react';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  type?: 'danger' | 'warning' | 'info' | 'success';
  isAlert?: boolean; // Se true, esconde o botão cancelar
  icon?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = "Confirmar",
  type = 'danger',
  isAlert = false,
  icon
}) => {
  if (!isOpen) return null;

  const themes = {
    danger: {
      icon: 'fa-triangle-exclamation',
      iconBg: 'bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400',
      btnBg: 'bg-red-600 hover:bg-red-700 text-white shadow-red-200 dark:shadow-none'
    },
    warning: {
      icon: 'fa-circle-exclamation',
      iconBg: 'bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400',
      btnBg: 'bg-amber-500 hover:bg-amber-600 text-white shadow-amber-200 dark:shadow-none'
    },
    info: {
      icon: 'fa-circle-info',
      iconBg: 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400',
      btnBg: 'bg-blue-600 hover:bg-blue-700 text-white shadow-blue-200 dark:shadow-none'
    },
    success: {
      icon: 'fa-circle-check',
      iconBg: 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400',
      btnBg: 'bg-emerald-600 hover:bg-emerald-700 text-white shadow-emerald-200 dark:shadow-none'
    }
  };

  const theme = themes[type];
  const displayIcon = icon || theme.icon;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center p-6 bg-slate-950/90 backdrop-blur-xl animate-in fade-in duration-200">
      <div 
        className="bg-white dark:bg-slate-900 w-full max-w-sm rounded-[2.5rem] p-8 shadow-2xl border border-slate-100 dark:border-slate-800 animate-in zoom-in-95 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col items-center text-center">
          <div className={`w-16 h-16 ${theme.iconBg} rounded-2xl flex items-center justify-center mb-6 text-2xl shadow-inner`}>
            <i className={`fa-solid ${displayIcon}`}></i>
          </div>
          
          <h3 className="text-xl font-black text-slate-900 dark:text-slate-100 mb-2 leading-tight uppercase tracking-tight">
            {title}
          </h3>
          
          <p className="text-sm font-medium text-slate-500 dark:text-slate-400 mb-8 leading-relaxed">
            {message}
          </p>
          
          <div className="flex flex-col w-full gap-3">
            <button 
              onClick={() => { if (!isAlert) onConfirm(); onClose(); }}
              className={`w-full py-4 rounded-2xl font-black text-[11px] uppercase tracking-widest shadow-lg active:scale-[0.98] transition-all ${theme.btnBg}`}
            >
              {isAlert ? "Entendido" : confirmText}
            </button>
            {!isAlert && (
              <button 
                onClick={onClose}
                className="w-full py-4 rounded-2xl font-black text-[11px] uppercase tracking-widest text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 active:scale-[0.98] transition-all"
              >
                Cancelar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
